import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

interface AuthRouteContext {
  hasEmail: boolean;
}

export const rootRoute = createRootRouteWithContext<AuthRouteContext>()({
  component: Outlet,
});
